<div class="promo-triple" role="list">
  <ng-container *ngFor="let slot of slots; trackBy: trackBySortOrder">
    <ng-container *ngIf="cellItem(slot.sortOrder) as item">
      <a
        *ngIf="cellLink(item) as link; else staticPromo"
        class="promo-triple__card"
        [class.promo-triple__card--main]="slot.sortOrder === 0"
        [routerLink]="link"
        role="listitem"
      >
        <ng-container *ngTemplateOutlet="promoInner; context: { $implicit: item, slot: slot }"></ng-container>
      </a>
      <ng-template #staticPromo>
        <div
          class="promo-triple__card"
          [class.promo-triple__card--main]="slot.sortOrder === 0"
          role="listitem"
        >
          <ng-container *ngTemplateOutlet="promoInner; context: { $implicit: item, slot: slot }"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<ng-template #promoInner let-item let-slot="slot">
  <app-media-slot *ngIf="item.mediaType !== 'video' && item.mediaUrl?.trim()" fit="cover" [rounded]="false" class="promo-triple__media-slot">
    <img
      class="promo-triple__media"
      [appMediaSrc]="item.mediaUrl"
      [appMediaProfile]="mediaProfileForSlot(slot)"
      [appMediaSlotHint]="slot.hintPx"
      [appMediaSizes]="sizesForSlot(slot)"
      [appMediaSharp]="true"
      [appMediaProgressive]="false"
      appMediaPlaceholder="/assets/placeholder.svg"
      [alt]="item.title || ''"
      loading="lazy"
      decoding="async"
      fetchpriority="low"
    />
  </app-media-slot>
  <video
    *ngIf="item.mediaType === 'video' && item.mediaUrl?.trim()"
    class="promo-triple__media"
    [appMediaSrc]="item.mediaUrl"
    muted
    loop
    playsinline
    autoplay
  ></video>
  <div class="promo-triple__hover" *ngIf="item.title || item.ctaText">
    <h3 class="promo-triple__title" *ngIf="item.title">{{ item.title }}</h3>
    <span class="promo-triple__cta">{{ item.ctaText || ('promo.discover_now' | t) }}</span>
  </div>
</ng-template>
